export const PRACTICE_TEAM = "practiceTeam";
export const STATES = "states";
export const MAX_PANEL = "maxPanelSize";
export const NEW_PATIENTS_DAILY_LIMIT = "newPatientsDailyLimit";
export const IS_PRINCIPAL = "isPrincipal";
export const SHARE_PANEL = "sharePanel";
export const NEW_PATIENT_STATES = "newPatientStates";
export const ACCEPT_NEW_PATIENTS = "acceptNewPatients";
